import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { ASSETS, CONTACT } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative bg-navy-deep border-t border-white/10 mt-24">
      <div className="mx-auto max-w-6xl px-6 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <span className="inline-flex bg-white rounded-full px-5 py-2 items-center gap-3.5">
            <img src={ASSETS.logo} alt="Ananya Refresh" className="h-10 w-auto" />
            <span className="w-px h-8 bg-slate-300" aria-hidden="true" />
            <img src={ASSETS.logoGold} alt="Ananya Gold" className="h-10 w-auto" />
          </span>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Packaged drinking water and bold-flavour snacks, built for high-volume retail across India.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-lime mb-5">Explore</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link data-testid="footer-link-home" to="/" className="text-slate-300 hover:text-sun-bright transition-colors">Home</Link>
            <Link data-testid="footer-link-products" to="/products" className="text-slate-300 hover:text-sun-bright transition-colors">Products</Link>
            <Link data-testid="footer-link-partnership" to="/partnership" className="text-slate-300 hover:text-sun-bright transition-colors">Partnership</Link>
            <Link data-testid="footer-link-consumer-goods" to="/consumer-goods" className="text-slate-300 hover:text-sun-bright transition-colors">Ananya Consumer Goods</Link>
            <Link data-testid="footer-link-about" to="/about" className="text-slate-300 hover:text-sun-bright transition-colors">Ananya Ventures</Link>
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-lime mb-5">Talk to Sales</p>
          <div className="flex flex-col gap-4 text-sm text-slate-300">
            <a data-testid="footer-phone" href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 hover:text-sun-bright transition-colors">
              <Phone size={16} className="text-lime" /> +91&nbsp;{CONTACT.phone}
            </a>
            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-sun-bright transition-colors">
              <Mail size={16} className="text-lime" /> {CONTACT.email}
            </a>
            <a data-testid="footer-email-alt" href={`mailto:${CONTACT.altEmail}`} className="flex items-center gap-3 hover:text-sun-bright transition-colors">
              <Mail size={16} className="text-lime" /> {CONTACT.altEmail}
            </a>
            <p data-testid="footer-address" className="flex items-center gap-3">
              <MapPin size={16} className="text-lime shrink-0" /> {CONTACT.address}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 py-6 text-center text-xs leading-relaxed text-slate-500">
        © {new Date().getFullYear()} Ananya Refresh. Pure. Safe. Refreshing.
      </div>
    </footer>
  );
}
